/* eslint-disable react/prop-types */
import React from "react"

import CheckboxFilter from "components/Algolia/Filters/CheckboxFilter"
//import ToggleFilter from "components/Algolia/Filters/ToggleFilter"
import RangeFilter from "components/Algolia/Filters/RangeFilter"

import { checkboxFilterLimit } from "config/filterConfig"

import { FilterConfig } from "@secureo/common/typings/Algolia"

const formatPrice = (cents: number) => (cents / 100).toLocaleString()

const Filter = ({ filterConfig, omitWrapper = false, onChildItems }: Props) => {
	const { attribute, label, type, hint, step } = filterConfig

	switch (type) {
		case "checkbox":
			return (
				<CheckboxFilter
					attribute={attribute}
					title={label}
					omitWrapper={omitWrapper}
					hint={hint}
					limit={checkboxFilterLimit}
				/>
			)

		case "range":
			switch (attribute) {
				case "grossPriceCents":
				case "netPriceCents":
					return (
						<RangeFilter
							attribute={attribute}
							title={label}
							formatter={formatPrice}
							step={step}
							omitWrapper={omitWrapper}
							hint={hint}
						/>
					)
				default:
					return (
						<RangeFilter
							attribute={attribute}
							title={label}
							step={step}
							omitWrapper={omitWrapper}
							onChildItems={onChildItems}
							hint={hint}
						/>
					)
			}

		// case "toggle":
		// 	return (
		// 		<ToggleFilter
		// 			attribute={attribute}
		// 			title={label}
		// 			label={label}
		// 			value={true}
		// 			omitWrapper={omitWrapper}
		// 			hint={hint}
		// 		/>
		// 	)

		default:
			return null
	}
}

interface Props {
	filterConfig: FilterConfig
	omitWrapper?: boolean
	onChildItems?: (numberOfItems: number) => void
}

export default Filter
